export const colors = {
    black: "#2A2522",
    darkGrey: "#554A44",
    white: "#FCFBF5",
    error: "#db4a37",
    errorBackground: "#ED8172",
    greyBackground: "#F4F2EC",
    greyBackgroundFocused: "#dedacc",
    elementBackground: "#F3D8B0",
    elementBackgroundFocused: "#F7D49F",
    accentBackground: "#FAEAC3",
    border: "#D9D4C7",
    google: "#EA4335",
    facebook: "#4267B2"
}

/** 
 * Based on typography object an app defines
 * family, margins and sizes of fonts.
 */
export const typography = {
    font: "'Open Sans', sans-serif",
    margins: {
        s: ".33em",
        m: ".66em",
        l: "1em"
    },
    sizes: {
        h1: "72px",
        h2: "48px",
        h3: "30px",
        h4: "20px",
        p: "16px",
        s: "14px"
    }
}

/** 
 * Based on breakpoints object an app decides
 * when website is a phone, tablet or desktop.
 */
export const breakpoints = {
    "phone-m": "480px",
    "tablet": "600px",
    "tablet-m": "768px",
    "tablet-l": "1024px",
    "desktop": "1200px",
    "desktop-m": "1366px",
    "desktop-l": "1600px"
}

/**
 * An interface to list rules how modifiers respond to breakpoints.
 */
export type ModifiersBreakpoints<T, K extends keyof any> = {
    [key in K]: {
        [key in keyof typeof breakpoints | "default"]?: T
    }
}
/**
 * Based on the columns object an app decides
 * how it should respond Grid block to breakpoints.
 */
const columns: ModifiersBreakpoints<number, "2" | "3" | "4" | "5"> = {
    "2": {
        "default": 1,
        "desktop": 2
    },
    "3": {
        "default": 1,
        "tablet": 2,
        "desktop": 3
    },
    "4": {
        "default": 1,
        "tablet": 2,
        "desktop": 4
    },
    "5": {
        "default": 1,
        "tablet": 2,
        "desktop": 5
    }
}

/**
 * Based on gaps object an app defines
 * how gaps respond to breakpoints.
 */
const gaps: ModifiersBreakpoints<string, "xs" | "s" | "m" | "l" | "xl"> = {
    xs: { "default": "10px" },
    s: { "default": "20px" },
    m: { "default": "30px" },
    l: {
        "default": "30px",
        "tablet": "60px"
    },
    xl: {
        "default": "30px",
        "tablet": "90px"
    }
}

/**
 * Based on grid object an app defines
 * global margins (left and right) and gaps.
 */
export const grid = {
    margins: {
        phone: "30px",
        tablet: "60px",
        desktop: "90px"
    },
    gaps,
    columns
}